import { URL_CONST } from 'utils/urlConsts'

export default function () {
  const initialState = {
    loader: false,
    items: {},
  }

  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
